/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {ReactNode, useEffect, useState} from 'react';
// style
import {StyledInput} from './Input.style';
import {InputBaseProps} from '@mui/material';

interface InputProps {
  className?: string;
  name?: string;
  label?: string;
  value?: string | number;
  disabled?: boolean;
  readOnly?: boolean;
  type?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  key?: string | number;
  onChange?: (e: any) => void;
  onBlur?: (e: any) => void;
  onKeyPress?: (e: any) => void;
  error?: boolean;
  helperText?: React.ReactNode;
  color?: 'error' | 'primary' | 'secondary' | 'info' | 'success' | 'warning';
  variant?: 'filled' | 'outlined' | 'standard';
  placeholder?: string;
  defaultValue?: string | number;
  inputComponent?: ReactNode | any;
  inputMode?: string | any;
  inputProps?: InputBaseProps['inputProps'];
}

function Input({
  className,
  name,
  label,
  value,
  disabled,
  type,
  size,
  key,
  fullWidth,
  onChange = (e: any) => {},
  onBlur,
  error,
  helperText,
  color = 'primary',
  variant = 'standard',
  readOnly = false,
  placeholder,
  inputComponent,
  inputMode,
  onKeyPress,
  defaultValue,
  ...other
}: InputProps) {
  const [state, setState] = useState<string | number | undefined>(value);
  useEffect(() => {
    setState(value);
  }, [value]);
  return (
    <>
      <StyledInput
        label={label}
        key={key}
        name={name}
        variant={variant}
        className={className}
        value={state ?? ''}
        disabled={disabled}
        onChange={e => {
          onChange(e);
        }}
        fullWidth={fullWidth}
        type={type}
        size={size}
        onBlur={onBlur}
        error={error}
        helperText={helperText}
        color={color}
        placeholder={placeholder}
        InputProps={{
          readOnly: readOnly,
          inputComponent: inputComponent,
          inputMode: inputMode,
          onKeyPress: onKeyPress,
        }}
        {...other}
      />
    </>
  );
}
export default Input;
